import { Box, Button, FormGroup, Stack, TextField } from '@mui/material'
import { Control, Controller } from 'react-hook-form'
import { ChangePasswordFormValues } from '../types'

type ChangePasswordFormProps = {
  control: Control<ChangePasswordFormValues>
  isValid: boolean
  onChangePassword: () => Promise<void>
  onChangePasswordCancel: () => void
}
export const ChangePasswordForm = ({
  control,
  isValid,
  onChangePassword,
  onChangePasswordCancel,
}: ChangePasswordFormProps) => {
  return (
    <Box component="form" noValidate paddingX={1} onSubmit={onChangePassword}>
      <FormGroup>
        <Controller
          control={control}
          name="newPassword"
          render={({ field, formState: { errors } }) => (
            <TextField
              {...field}
              label="新パスワード"
              type="password"
              variant="outlined"
              size="small"
              margin="normal"
              onChange={field.onChange}
              autoComplete="new-password"
              error={!!errors.newPassword}
              helperText={errors.newPassword?.message}
              required
              fullWidth
            />
          )}
        />
        <Controller
          control={control}
          name="confirmNewPassword"
          render={({ field, formState: { errors } }) => (
            <TextField
              {...field}
              label="もう一度入力"
              type="password"
              variant="outlined"
              size="small"
              margin="normal"
              onChange={field.onChange}
              autoComplete="current-password"
              error={!!errors.confirmNewPassword}
              helperText={errors.confirmNewPassword?.message}
              required
              fullWidth
            />
          )}
        />
      </FormGroup>

      <Stack direction="column" spacing={1} sx={{ mt: 3 }}>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
          disabled={!isValid}
        >
          OK
        </Button>
        <Button fullWidth variant="outlined" onClick={onChangePasswordCancel}>
          キャンセル
        </Button>
      </Stack>
    </Box>
  )
}
